export const getClientSideId = () => window.SS_GLOBALS.frontEndConfig.launchDarklyClientSideId;
export const getLaunchDarklyProfile = () => window.SS_GLOBALS.launchDarklyProfile || '';
export const getLaunchDarklyFeatureFlags = () => window.SS_GLOBALS.launchDarklyFeatureFlags || '';
export const getLaunchDarklyAnonymousFeatureFlags = () => window.SS_GLOBALS.launchDarklyAnonymousFeatureFlags || '';

export const getOptions = (additional) => {
  return {
    evaluationReasons: true,
    sendEventsOnlyForVariation: true,
    ...additional,
  };
};
